<template>
    <slot name="before" />

    <template
        v-for="(contentBlock, index) in filteredContentBlocks"
        :key="`contentBlock_${index}`"
    >
        <LazyVisibleContentBlocksText
            v-if="contentBlock.__typename === 'contentBlocks_richText_BlockType'"
            hydrate-on-visible
            v-bind="contentBlock"
        />

        <LazyVisibleContentBlocksTable
            v-if="contentBlock.__typename === 'contentBlocks_table_BlockType'"
            hydrate-on-visible
            v-bind="contentBlock"
        />

        <LazyVisibleContentBlocksVideo
            v-if="contentBlock.__typename === 'contentBlocks_video_BlockType'"
            hydrate-on-visible
            v-bind="contentBlock"
        />

        <LazyVisibleContentBlocksTextVideo
            v-if="contentBlock.__typename === 'contentBlocks_textVideo_BlockType'"
            hydrate-on-visible
            v-bind="contentBlock"
        />

        <LazyNeverContentBlocksImages
            v-if="contentBlock.__typename === 'contentBlocks_images_BlockType'"
            hydrate-never
            v-bind="contentBlock"
        />

        <LazyNeverContentBlocksQuote
            v-if="contentBlock.__typename === 'contentBlocks_quote_BlockType'"
            hydrate-never
            v-bind="contentBlock"
        />

        <LazyVisibleContentBlocksAccordion
            v-if="contentBlock.__typename === 'contentBlocks_accordion_BlockType'"
            hydrate-on-visible
            v-bind="contentBlock"
        />

        <LazyVisibleContentBlocksCallToAction
            v-if="contentBlock.__typename === 'contentBlocks_callToAction_BlockType'"
            hydrate-on-visible
            v-bind="contentBlock"
        />

        <LazyVisibleContentBlocksContentOverview
            v-if="contentBlock.__typename === 'contentBlocks_contentOverview_BlockType'"
            hydrate-on-visible
            v-bind="contentBlock"
        />

        <LazyIdleContentBlocksContentSlider
            v-if="contentBlock.__typename === 'contentBlocks_cardSlider_BlockType'"
            hydrate-on-idle
            v-bind="contentBlock"
        />

        <LazyIdleContentBlocksSummaryCards
            v-if="contentBlock.__typename === 'contentBlocks_summaryCards_BlockType'"
            hydrate-on-idle
            v-bind="contentBlock"
        />

        <!-- Added by formie layer -->
        <LazyVisibleContentBlocksJotform
            v-if="contentBlock.__typename === 'contentBlocks_form_BlockType'"
            hydrate-on-visible
            v-bind="contentBlock"
        />
    </template>

    <slot name="after" />
</template>

<script setup lang="ts">
type ShouldBeBlock = {
    __typename?: string;
}

const props = defineProps<{
    contentBlocks: ShouldBeBlock[]
}>();

const { contentBlocks } = toRefs(props);

const shouldRender = (contentBlock: ShouldBeBlock) => {
    if (!contentBlock) {
        return false;
    }

    if (!contentBlock.__typename) {
        return false;
    }

    return true;
};

const filteredContentBlocks = computed(() => {
    return contentBlocks.value?.filter(contentBlock => shouldRender(contentBlock));
});
</script>

<style lang="less">
.content-block__call-to-action {
    margin-top: var(--spacing-sm);

    @media @q-md-min {
        margin-top: var(--spacing-md);
    }
}
</style>
